// TODO(FUS-000): common module?

import { localStorageContext } from './localStorage.context';

export const getItem = (key: string): unknown => {
  const string = localStorage.getItem(key);
  try {
    return JSON.parse(string!);
  } catch (err) {
    localStorageContext.captureException(err, {
      level: 'warning',
      tags: {
        utility: 'localStorage',
        operation: 'getItem',
        key,
      },
      extra: {
        storedValue: string,
      },
    });
    return string;
  }
};

export const setItem = (key: string, data: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (err) {
    localStorageContext.captureException(err, {
      level: 'warning',
      tags: {
        utility: 'localStorage',
        operation: 'setItem',
        key,
      },
      extra: {
        dataType: typeof data,
      },
    });
  }
};

export const removeItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    localStorageContext.captureException(err, {
      level: 'warning',
      tags: {
        utility: 'localStorage',
        operation: 'removeItem',
        key,
      },
    });
  }
};

export const hasItem = (key: string): boolean => {
  try {
    return localStorage.getItem(key) !== null;
  } catch (err) {
    localStorageContext.captureException(err, {
      level: 'warning',
      tags: {
        utility: 'localStorage',
        operation: 'hasItem',
        key,
      },
    });
    return false;
  }
};
